import { css as e } from "styled-components";
const r = (o) => o.componentColors.toggleSwitch, t = "18px", d = {
  base: () => /* @__PURE__ */ e([
    "cursor:pointer;display:flex;justify-content:center;align-items:center;flex-shrink:0;height:2.4rem;min-width:4rem;box-sizing:border-box;border-style:solid;border-width:0.2rem;border-radius:2rem;transition:background-color 0.3s ease;position:relative;padding:1.2rem 0.5rem;@media (prefers-reduced-motion){transition:none;}&:after{content:'';position:absolute;width:",
    ";height:",
    ";border-radius:100%;transition:all 0.3s ease;@media (prefers-reduced-motion){transition:none;}}"
  ], t, t),
  text: ({ theme: o }) => /* @__PURE__ */ e([
    "transition:opacity 0.3s ease;color:",
    ";"
  ], r(o).uncheckedText),
  hidden: ({ theme: o, error: i }) => /* @__PURE__ */ e([
    "position:absolute;opacity:0;height:1px;width:1px;&:focus{& ~ .styled-toggle-switch{",
    " border-radius:2rem;border-color:",
    ";}}& ~ .styled-toggle-switch{border-color:",
    ";background-color:",
    ";&:after{background-color:",
    ";left:2px;}> span:first-child{opacity:0;margin-right:auto;padding-left:0.5rem;color:",
    ";}> span:last-child{opacity:1;padding-left:",
    ";padding-right:0.5rem;margin-left:auto;color:",
    ";}}&:checked{& ~ .styled-toggle-switch{border-color:",
    ";background-color:",
    ";&:after{background-color:",
    ";left:calc(100% - ",
    " - 2px);}> span:first-child{opacity:1;}> span:last-child{opacity:0;}}}"
  ], o.components.forms.borderStyle, r(o).checked, i ? r(o).error : r(o).border, r(o).unchecked, r(o).uncheckedDot, r(o).checkedText, o.space.xs, r(o).uncheckedText, r(o).checked, r(o).checked, r(o).checkedDot, t)
};
export {
  d as default
};
